import apiClient from './client';
import { Project, TrainingSet, CreateProjectData } from '../state/atoms';

export interface LoginResponse {
  success: boolean;
  token: string;
  project: Project;
}

export interface DashboardStats {
  trainingSetCount: number;
  isVectorTrained: boolean;
  lastTrainedAt: string | null;
  paragraphCount: number;
}

export const adminAPI = {
  // Auth
  login: async (projectCode: string, password: string): Promise<LoginResponse> => {
    const { data } = await apiClient.post('/admin/login', { projectCode, password });
    return data;
  },

  verify: async (): Promise<{ valid: boolean; project: Project }> => {
    const { data } = await apiClient.get('/admin/verify');
    return data;
  },

  // Dashboard
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await apiClient.get('/admin/stats');
    return data;
  },

  // Training Sets
  getTrainingSets: async (): Promise<{ trainingSets: TrainingSet[] }> => {
    const { data } = await apiClient.get('/admin/training-sets');
    return data;
  },

  createTrainingSet: async (question: string, answer: string): Promise<{ trainingSet: TrainingSet }> => {
    const { data } = await apiClient.post('/admin/training-sets', { question, answer });
    return data;
  },

  updateTrainingSet: async (id: string, question: string, answer: string): Promise<{ trainingSet: TrainingSet }> => {
    const { data } = await apiClient.put(`/admin/training-sets/${id}`, { question, answer });
    return data;
  },

  deleteTrainingSet: async (id: string): Promise<{ success: boolean }> => {
    const { data} = await apiClient.delete(`/admin/training-sets/${id}`);
    return data;
  },

  reorderTrainingSets: async (updates: Array<{ id: string; order_index: number }>): Promise<{ success: boolean }> => {
    const { data } = await apiClient.post('/admin/training-sets/reorder', { updates });
    return data;
  },

  retrain: async (): Promise<{ success: boolean; message: string }> => {
    const { data } = await apiClient.post('/admin/retrain');
    return data;
  },

  // Project Management (Super User Only)
  getAllProjects: async (): Promise<{ projects: Project[] }> => {
    const { data } = await apiClient.get('/admin/projects');
    return data;
  },

  createProject: async (projectData: CreateProjectData): Promise<{ project: Project }> => {
    const { data } = await apiClient.post('/admin/projects', projectData);
    return data;
  },

  updateProject: async (id: string, projectData: Partial<CreateProjectData>): Promise<{ project: Project }> => {
    const { data } = await apiClient.put(`/admin/projects/${id}`, projectData);
    return data;
  },

  deleteProject: async (id: string): Promise<{ success: boolean }> => {
    const { data } = await apiClient.delete(`/admin/projects/${id}`);
    return data;
  },
};

